import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FaServicestack, FaUser, FaList, FaArrowRight, FaArchive, FaGratipay, FaBookOpen, FaCandyCane, FaBuilding, FaHeartbeat } from 'react-icons/fa';
import { useAuth } from './../../Auth/AuthContext';
import { savePermisosPaginas, getPermisosPaginas } from './../Utils/indexedDBUtils';

const MenuReincorporados = ({ idCabezaFamilia }) => {
    const { rol, fetchPermisosPaginas } = useAuth();
    const [permisosPaginas, setPermisosPaginas] = useState([]);
    async function consultarPermisosPaginas() {
        const cachedPermisos = await getPermisosPaginas();
        if (cachedPermisos) {
            setPermisosPaginas(cachedPermisos);
        } else {
            const permisos = await fetchPermisosPaginas();
            if (permisos) {
                setPermisosPaginas(permisos);
                await savePermisosPaginas(permisos);
            }
        }
    }
    useEffect(() => {
        consultarPermisosPaginas()
    }, [fetchPermisosPaginas]);
    const section1Links = [
        { 
            to: `/reincorporados/grupofamiliarrei/${idCabezaFamilia}`, 
            tooltip: "Persona", 
            icon: <FaUser size={20} />, 
            label: "Persona", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Grupo Familiar")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) 
        },
        { 
            to: `/reincorporados/ubicacionrei/${idCabezaFamilia}`, 
            tooltip: "Ubicacion", 
            icon: <FaServicestack size={20} />, 
            label: "Ubicacion", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Ubicacion")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  
        },
        { 
            to: `/reincorporados/hechosvictimizantesrei/${idCabezaFamilia}`, 
            tooltip: "Hechos", 
            icon: <FaHeartbeat size={20} />, 
            label: "Hechos", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Hechos victimizantes rei")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  
        },
        { 
            to: `/reincorporados/desembolsos/${idCabezaFamilia}`, 
            tooltip: "Registrar desembolsos", 
            icon: <FaArchive size={20} />, 
            label: "Desembolsos", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Desembolso Reincorporados")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)),
        },
        { 
            to: `/reincorporados/prevencionrei/${idCabezaFamilia}`, 
            tooltip: "Asesoría Jurídica", 
            icon: <FaGratipay size={20} />, 
            label: "Asesoría Jurídica", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Prevencion Reincorporados")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  
        },
        { 
            to: `/reincorporados/proteccionrei/${idCabezaFamilia}`, 
            tooltip: "Protección", 
            icon: <FaGratipay size={20} />, 
            label: "Protección", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Proteccion Reincorporados")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  
        },
        { 
            to: `/reincorporados/feriaserviciosrei/${idCabezaFamilia}`, 
            tooltip: "Feria de servicios", 
            icon: <FaCandyCane size={20} />, 
            label: "Feria de servicios", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Feria de servicios Reincorporados")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  
        },
        { 
            to: `/reincorporados/educacionrei/${idCabezaFamilia}`, 
            tooltip: "Educación", 
            icon: <FaBookOpen size={20} />, 
            label: "Educación", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Educacion Reincorporados")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  
        },
        { 
            to: `/reincorporados/empleabilidadrei/${idCabezaFamilia}`, 
            tooltip: "Empleabilidad", 
            icon: <FaBuilding size={20} />, 
            label: "Empleabilidad", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Empleabilidad Reincorporados")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))  
        },
        { 
            to: `/reincorporados/unidadesproductivasrei/${idCabezaFamilia}`, 
            tooltip: "Unidades productivas", 
            icon: <FaBuilding size={20} />, 
            label: "Unidades productivas", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Unidades productivas Reincorporados")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        },
        { 
            to: `/reincorporados/restaurativosrei/${idCabezaFamilia}`, 
            tooltip: "Procesos restaurativos", 
            icon: <FaHeartbeat size={20} />, 
            label: "Procesos restaurativos", 
            className: "btn btn-app bg-primary", 
            hidden: !permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Procesos restaurativos Reincorporados")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol))
        }
    ];

    const section2Links = [
        { to: `/reincorporados/crearatencionrei/${idCabezaFamilia}`, tooltip: "Registrar atencion", icon: <FaList size={20} />, label: "Atencion", className: "btn btn-app bg-info" },
        { to: `/reincorporados/crearderivacionesrei/${idCabezaFamilia}`, tooltip: "Registrar derivacion", icon: <FaArrowRight size={20} />, label: "Derivacion", className: "btn btn-app bg-info" },
        { to: `/reincorporados/consultaatencionesrei/${idCabezaFamilia}`, tooltip: "Consulta de registros", icon: <FaList size={20} />, label: "Registros" , className: "btn btn-app bg-info" },
    ];

    const renderLinks = (links) => {
        return links.map((link, index) => (
            !link.hidden && (
                <NavLink
                    key={index}
                    to={link.to}
                    className={link.className}
                    data-tooltip-id="tooltiparriba"
                    data-tooltip-content={link.tooltip}
                >
                    {link.icon}
                    <p>{link.label}</p>
                </NavLink>
            )
        ));
    };

    return (
        <div className="card">
            <div>
                <div className="row">
                    <div className="col-md-12 no-padding">
                        {renderLinks(section1Links)}
                    </div>
                </div>
            </div>
            <div>
                <div className="row">
                    <div className="col-md-12 no-padding">
                        {renderLinks(section2Links)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenuReincorporados;